import { useState, useEffect } from 'react';

export default function Popup() {
  const [visible, setVisible] = useState(false);
  const [dontShowToday, setDontShowToday] = useState(false);

  useEffect(() => {
    const hideUntil = localStorage.getItem('popup_hide_until');
    if (hideUntil) {
      const now = new Date().getTime();
      if (now < parseInt(hideUntil, 10)) {
        return;
      }
      localStorage.removeItem('popup_hide_until');
    }
    setVisible(true);
  }, []);

  const handleClose = () => {
    if (dontShowToday) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      localStorage.setItem('popup_hide_until', tomorrow.getTime().toString());
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={handleClose} />
      <div className="relative z-10 w-full max-w-lg animate-fade-in">
        <img
          alt="놓칠 수 없는 6가지 이유"
          className="w-full h-auto rounded-xl"
          src="https://www.xn--2w2b1dm8gn5nwya81ag35e.com/assets/images/popup/popup_260604_03.png"
        />
        <div className="flex items-center justify-between mt-3 px-1">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              className="w-4 h-4 rounded border-background-300 bg-background-200 text-primary-500 focus:ring-primary-500"
              checked={dontShowToday}
              onChange={(e) => setDontShowToday(e.target.checked)}
            />
            <span className="text-xs text-foreground-700">오늘 하루 보지않기</span>
          </label>
          <button
            onClick={handleClose}
            className="text-sm font-medium text-foreground-700 hover:text-foreground-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            팝업닫기 <span className="text-lg leading-none">&times;</span>
          </button>
        </div>
      </div>
    </div>
  );
}